<div [formGroup]="invoiceEmailForm" class="form flex flex-col">
  <nx-edit-text-input
    formControlName="invoiceEmail"
    placeholder="rechnung@nexato.de"
    label="Abweichende Rechnungs Email-Adresse">
  </nx-edit-text-input>
<div>